
import { QueryClient } from '@tanstack/react-query';

// Create a shared queryClient instance to be used across subscription hooks
export const queryClient = new QueryClient();
